<template>
  <header class="items-left">
    <vs-row class="row-res">
      <vs-col class="vs-lg-6 vs-xs-10" style="position:relative;">
    <h1 class="header__h1 mb-5">GetBoarded to a fresh Career</h1>
    <img class="underline" src="@/assets/images/aboutUs/underline.png" alt="">
    <p class="header__p">Our mission is to empower the world's professionals to take control of their personal brand and become more successful.</p>
    <div class="btn mt-10">
      <router-link to="/user/dashboard">
    <vs-button class="get-started">Get Started</vs-button>
      </router-link>
    <!-- <img class="videoImg" @click="popupActivo=true"  src="@/assets/images/aboutUs/videoBtn.svg" alt="video"/>
    <span class="watch ml-3">Watch Video</span>
    <vs-popup class="holamundo"  title="Welcome to GetBoarded" :active.sync="popupActivo">
      <iframe width="590" height="497" src="youtube-link add here" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </vs-popup> -->
   </div>
      </vs-col>
      <vs-col class="vs-lg-5 vs-xs-10">
<img class="intro-img" src="@/assets/images/aboutUs/intro-image.png" alt="">
      </vs-col>
    </vs-row>
  </header>
</template>

<script>
    export default {
        name: "Header",
        data() {
          return {
            // popupActivo:false,
          }
        }
    }
</script>

<style scoped>
.videoImg {
  cursor: pointer;
}
.watch {
  font-style: normal;
font-weight: 500;
font-size: 18px;
line-height: 60px;
letter-spacing: 0.02em;
color: #282C4B;
}
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }

  header {
    width: 100%;
    padding: 0 7rem;
    background: url(../../../../assets/images/aboutUs/triangle.png);
    background-size: cover;
  }

  /*===============================================*/
  /* Header		 						 */
  /*===============================================*/

  .header__h1 {
    padding-top: 100px;
    text-transform: capitalize;
font-style: normal;
font-weight: bold;
font-size: 58px;
line-height: 80px;
letter-spacing: 0.02em;
color: #121127;
  }
  .header__p {
font-style: normal;
font-weight: normal;
font-size: 20px;
line-height: 36px;
color: #5D6473;
  }

  .btn {
    text-align: left;
    display: flex;
  }
.get-started {
  margin-right: 30px;
padding: 18px 40px!important;
font-style: normal;
font-weight: bold;
font-size: 18px;
line-height: 21px;
text-align: center;
letter-spacing: 0.02em;

color: #FFFFFF;
background: linear-gradient(97.32deg, #FFC975 -3.47%, #F29300 108.43%)!important;
border: 2px solid rgba(255, 255, 255, 0.8);
box-shadow: 0px 30px 50px rgba(242, 147, 0, 0.2)!important;
}
.underline {
  top: 41%;
    position: absolute;
    right: 30%;
}
  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    .row-res {
      flex-direction: column-reverse;
      align-items: center;
    }
    .intro-img {
      height: 300px;
    }
    .header__h1 {
          font-size: 36px;
    line-height: 52px;
    }
    .header__p {
      font-size: 16px;
line-height: 30px;
    }
    .underline {
      display: none;
    }
    header {
      padding: 0;
      padding-bottom: 20px;
    }
  }
</style>
